// this needs to be the first import since it determines the cdn location of resources
import "./../src/publicPath.ts";

import "core-js/stable";
import "regenerator-runtime/runtime";
import "whatwg-fetch";
import "../src/helpers/nodelist-foreach-polyfill";
import "../script/jquery.hoverintent.js";
import "../script/jquery.reveal.js";
import "../script/dropdown-menu.js";
import "../script/jquery.validate.js";
import "../script/jquery.lazyloadxt.js";
import "../script/jquery.lazyloadxt.srcset.js";
import "../script/shave.js";
import {Tracking} from "../src/tracking/tracking";
import {loadFlashsales} from "../src/helpers/loadFlashsales";

var c = {
  config: {
    // Globale Settings
    filterList: true,
    CategoryId: 0,
    CategoryTypeId: 0,
    width: window.innerWidth > 0 ? window.innerWidth : screen.width,
    lang: "de",
    breakpointTablet: 481,
    breakpointTabletLarge: 768,
    breakpointDesktop: 940,
    breakpointDesktopLarge: 1120,
  },
  storage: {
    get(id, fromSession) {
      fromSession = typeof fromSession !== "undefined" ? fromSession : false;

      const item = fromSession ? sessionStorage.getItem(id) : localStorage.getItem(id);

      if (item === null) {
        return false;
      }

      return JSON.parse(item);
    },
    /*
     * Parameter: id, value
     */
    set(key, data, toSession) {
      toSession = typeof toSession !== "undefined" ? toSession : false;
      const item = {
        value: data,
        created: new Date().getTime(),
      };
      toSession ? sessionStorage.setItem(key, JSON.stringify(item)) : localStorage.setItem(key, JSON.stringify(item));
    },
  },
  tracking: {
    // sendEvent kapseln, damit die Funktion auf window zur Verfügung steht (für alten Code in Templates)
    sendEvent(eventName) {
      Tracking.sendEvent(eventName);
    },
  },
  sessionCookie: {
    get(key) {
      const name = key + "=";
      const decodedCookie = decodeURIComponent(document.cookie);
      const ca = decodedCookie.split(";");
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == " ") {
          c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
          return c.substring(name.length, c.length);
        }
      }

      return false;
    },
    set(key, value) {
      document.cookie = key + "=" + value + ";path=/";
    },
    remove(key) {
      document.cookie = key + "=;expires=Thu, 01 Jan 1970 00:00:01 GMT";
    },
  },
  init(config) {
    const conf = this.config;

    // config Parameter einlesen
    $.extend(conf, config);

    // Hauptnavigation initialisieren
    c.mainNavigation.init();

    // Sprache des Form-Validators initialisieren
    c.initValidator.init(config.lang);

    // Externe Javascript-Links initialisieren (<span data-href-blank="http://...">)
    $("[data-href-blank]").on("click", function (e) {
      e.preventDefault();
      const newTab = window.open();
      newTab.opener = null;
      newTab.location = $(this).data("href-blank");
    });

    // Interne Javascript-Links initialisieren (<span data-href="http://...">)
    $("[data-href]:not(.button-disabled)").on("click", function (e) {
      e.preventDefault();
      window.location.href = $(this).data("href");
    });

    // "Akkordeon"-Aufklappbereiche initialisieren (zur Zeit nur auf Produktdetailseiten)
    $(".accordion .accordion__item__headline").on("click", function () {
      $(this).parent().toggleClass("active");
      Tracking.sendEvent("PdsAccordionClicked");
    });

    // Formularfelder für Geburtstag initialisieren
    if ($("#Birthday").length) {
      this.initBirthday();
    }

    // Formular-Validierungs-Engine initialisieren
    const $forms = $("form.validate");
    if ($forms.length) {
      $forms.each(function () {
        $(this).validate({
          errorPlacement(error, element) {
            error.appendTo(element.parent());

            return false;
          },
          ignore: $(this).hasClass("validate-hidden") ? "" : ":hidden",
        });
      });
      $forms.find(".required input, .required select, .required textarea").each(function () {
        $(this).rules("add", {required: true});
      });
      $forms.find("#Password").each(function () {
        $(this).rules("add", {minlength: 8});
        $forms.find("#Password_Repeat").each(function () {
          $(this).rules("add", {equalTo: "#Password"});
        });
      });
      $forms.find("#Password_New").each(function () {
        $(this).rules("add", {minlength: 8});
        $forms.find("#Password_Repeat").each(function () {
          $(this).rules("add", {equalTo: "#Password_New"});
        });
      });
    }

    // Aufklappbare Textblöcke initialisieren (für Hilfeseiten o.ä.)
    if ($(".drop-title").length && $(".drop-content").length) {
      c.dropDownText.init();
    }

    // Aufklappbare Contentblöcke initialisieren (für Footer o.ä.)
    $(".container").on("click", ".container__item--drawer .container__item__title", function () {
      $(this).parent().toggleClass("container__item--drawer-open");
    });

    // Ggf. Formular-Felder mittels Localstorage wieder befüllen
    if (localStorage) {
      c.formStorage(true);
    }

    // Liste der Artikelbewertungen initialisieren
    this.initProductReview();

    // Promobanner fixiert unten
    const $TopBarBottom = $(".top-bar--bottom");
    if ($TopBarBottom.length) {
      (function () {
        const thresh = 60;
        const $window = $(window);
        let visible = window.scrollY < thresh;
        if (!visible) $TopBarBottom.slideUp();
        $window.on(
          "scroll",
          c.throttle(function () {
            if (visible && window.scrollY >= thresh) {
              $TopBarBottom.slideUp(200);
              visible = !visible;
            } else if (!visible && window.scrollY < thresh) {
              $TopBarBottom.slideDown(200);
              visible = !visible;
            }
          }, 200),
        );
      })();
    }

    // Toggle-Button (Mobilansicht) für Filterlisten initialisieren
    const $mobiletogglebutton = $(".mobile-toggle-button");
    if ($mobiletogglebutton.length) {
      $mobiletogglebutton.on("click", function () {
        $(".mobile-toggle").toggleClass("mobile-toggle-show");
        $(".mobile-toggle-button>span").toggleClass("icon-chevron-down").toggleClass("icon-chevron-up");
      });
    }

    // Löschformular im Kundenkonto initialisieren
    const $AccountDeletionForm = $("#AccountDeletionForm");
    if ($AccountDeletionForm.length) {
      c.accountDeletion($AccountDeletionForm);
    }

    // Special Offer init
    this.specialOffer.init();

    // Blog-News
    this.blogNews.init();

    // Lese-Fortschritt initialisieren
    const $ProgressContainer = $(".progress-container");
    if ($ProgressContainer.length) {
      (function () {
        const $window = $(window);
        const $blogEntryTop = $(".blog-entry");
        const $blogEntryBottom = $(".blog-entry + section");

        let winHeight;
        let blog_entry_top;
        let blog_entry_bottom;
        let blog_height;

        let curr_abs_pos;
        let curr_blog_pos;
        let curr_value;
        let curr_percent_val;

        let visible = false;
        const getTransform = function (value) {
          const prefixes = ["", "-webkit-", "-ms-"];
          let css = "";
          Array.prototype.forEach.call(prefixes, function (prefix) {
            css += prefix + "transform: scale(" + value.toFixed(4) + ",1);";
          });

          return css;
        };

        $window.on(
          "scroll",
          c.throttle(function () {
            curr_abs_pos = $window.scrollTop();
            curr_blog_pos = curr_abs_pos - blog_entry_top;
            curr_value = curr_blog_pos / blog_height;
            curr_percent_val = curr_value * 100.0;

            $(".progress-bar", $ProgressContainer).attr({style: getTransform(curr_value)});

            if (curr_percent_val >= 0.0 && curr_percent_val <= 102.0 && !visible) {
              $ProgressContainer.addClass("visible");
              visible = true;
            } else if ((curr_percent_val < 0.0 || curr_percent_val > 104.0) && visible) {
              $ProgressContainer.removeClass("visible");
              visible = false;
            }
          }, 200),
        );

        $window.resize(function () {
          winHeight = $window.height();
          blog_entry_top = $blogEntryTop.offset().top;
          blog_entry_bottom = $blogEntryBottom.offset().top - winHeight;
          blog_height = blog_entry_bottom - blog_entry_top;
          $window.scroll();
        });

        $window.resize();
      })();
    }

    // Init Kundenbereich-Icon-Badge (nur wenn Element vorhanden)
    if ($("#HeaderAccountIconBadge").length) {
      this.accountBadge.init();
    }

    // Kundenbereich-Pop-ups ggf. anzeigen (nur wenn entsprechendes LocalStorage-Flag gesetzt und Popup existiert)
    if (c.sessionCookie.get("c_showFlashsalePopup") === "1" && $("#FlashsalePopup").length) {
      const name = c.sessionCookie.get("c_flashsalePopupName");
      const time = c.sessionCookie.get("c_flashsalePopupTime");
      const path = c.sessionCookie.get("c_flashsalePopupPath");
      this.accountBadge.showFlashsalePopup(name, time, path);
      c.sessionCookie.remove("c_showFlashsalePopup");
    }

    // Neuheiten mit Ambientebild auf der Startseite
    const $NewProductsBlock = $("#NewProductsBlock");
    if ($NewProductsBlock.find(".list-products a").length) {
      $NewProductsBlock.show();
    }

    // Initialisierung Produktlisten - Umschalter Freisteller/Stimmungsbilder
    const $listproductsitem = $(".list-products__item > .productname");
    if ($listproductsitem.length) {
      $listproductsitem.each(function (i, v) {
        $(v).data("text", v.innerText);
      });
      $listproductsitem.shave(70);
      $(window).resize(function () {
        $listproductsitem.each(function (i, v) {
          v.innerHTML = $(v).data("text");
        });
        $listproductsitem.shave(70);
      });
    }

    // Breadcrumbs nach dem Laden oder beim resize immer Rechtsbündig anzeigen
    const bc = document.querySelector("#breadcrumb");
    if (bc !== null) {
      $(window).on("load resize", function () {
        bc.scrollLeft = 9999;
      });
    }

    // Teaser Block Buttons zum Aufklappen auf Brand Shop Seiten in der Desktop-Ansicht
    const teaserButtons = document.querySelectorAll(".button-teaser-show");
    if (teaserButtons.length) {
      teaserButtons.forEach(function (teaserButton) {
        // Alle Halbtransparenten und Unsichtbaren vorab speichern
        const ParentSection = document.querySelector(teaserButton.dataset.parentSectionId);
        const hiddenElements = ParentSection.querySelectorAll(".max-tablet");
        const hollowElements = ParentSection.querySelectorAll(".teaser-wrapper__swiper--item--hollow");
        let notLoaded = true;

        teaserButton.addEventListener("click", function () {
          // gerade im eingeklappten Modus?
          const isInHiddenState = teaserButton.dataset.state === "hidden";

          // versteckte Elemente ab 9. Element/3. Zeile, Sichtbarkeit in Desktop-Ansicht togglen
          if (hiddenElements.length) {
            hiddenElements.forEach(function (hiddenElement) {
              // wenn eingeklappt: mit .max-tablet class in Desktop-Ansicht (min-height: 768px)
              // unsichtbar machen, mobil kein Effekt, weil immer sichtbar und css-Slider
              isInHiddenState
                ? hiddenElement.classList.remove("max-tablet")
                : hiddenElement.classList.add("max-tablet");
            });

            // bei erster Sichtbarkeit lazy load anstoßen
            if (notLoaded && isInHiddenState) {
              $(hiddenElements).lazyLoadXT();
              notLoaded = false;
            }
          }

          // halbtransparente Teaserelemente, 5.-8. Element in der zweiten Zeile, opacity in Desktop-Ansicht togglen
          if (hollowElements.length) {
            hollowElements.forEach(function (hollowElement) {
              // wenn eingeklappt: mit '..--hollow' class in desktop (min-height: 768px)
              // halbtransparent, mobil kein Effekt, weil komplett sichtbar und css-Slider
              isInHiddenState
                ? hollowElement.classList.remove("teaser-wrapper__swiper--item--hollow")
                : hollowElement.classList.add("teaser-wrapper__swiper--item--hollow");
            });
          }

          // hidden state und Wording togglen
          if (isInHiddenState) {
            teaserButton.dataset.state = "shown";
            teaserButton.innerText = teaserButton.dataset.hideAllText;
          } else {
            teaserButton.dataset.state = "hidden";
            teaserButton.innerText = teaserButton.dataset.showAllText;
          }
        });
      });
    }
  },

  throttle(func, wait) {
    let context;
    let args;
    let result;
    let timeout = null;
    let previous = 0;
    const later = function () {
      previous = date_now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };

    var date_now =
      Date.now ||
      function () {
        return new Date().getTime();
      };

    return function () {
      const now = date_now();
      const remaining = wait - (now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = now;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout) {
        timeout = setTimeout(later, remaining);
      }

      return result;
    };
  },

  revealPopup(selector) {
    $(selector).reveal({
      animation: "fade",
      animationspeed: 200,
      closeonbackgroundclick: true,
    });
  },

  initRatingForm(url, itemId) {
    $("#PluginContainer").load(url, function () {
      $("#ProductRatingFormContainer").find("#ItemId").val(itemId);
      const $form = $("form.validate");
      $form.validate({
        errorPlacement(error, element) {
          if (element[0].name == "Rating") {
            error.appendTo(element.parent().parent());
          } else {
            error.appendTo(element.parent());
          }
        },
        rules: {
          Rating: {
            required: true,
          },
          Subject: {
            required: true,
            minlength: 10,
          },
          Content: {
            required: true,
            minlength: 50,
          },
        },
      });
    });
    $("#RatingPopup").reveal();

    return false;
  },

  initValidator: {
    messages: {
      de: {
        required: "Dies ist ein Pflichtfeld.",
        maxlength: $.validator.format("Geben Sie bitte maximal {0} Zeichen ein."),
        minlength: $.validator.format("Geben Sie bitte mindestens {0} Zeichen ein."),
        rangelength: $.validator.format("Geben Sie bitte mindestens {0} und maximal {1} Zeichen ein."),
        email: "Bitte geben Sie eine gültige E-Mail-Adresse ein.",
        url: "Bitte geben Sie eine gültige URL ein.",
        date: "Bitte geben Sie ein gültiges Datum ein.",
        number: "Bitte geben Sie eine Zahl ein.",
        digits: "Bitte geben Sie nur Ziffern ein.",
        equalTo: "Die Eingaben stimmen nicht überein.",
        range: $.validator.format("Geben Sie bitte einen Wert zwischen {0} und {1} ein."),
        max: $.validator.format("Geben Sie bitte einen Wert kleiner oder gleich {0} ein."),
        min: $.validator.format("Geben Sie bitte einen Wert größer oder gleich {0} ein."),
        creditcard: "Geben Sie bitte eine gültige Kreditkarten-Nummer ein.",
      },
      da: {
        required: "Dette felt er påkrævet.",
        maxlength: $.validator.format("Indtast højst {0} tegn."),
        minlength: $.validator.format("Indtast mindst {0} tegn."),
        rangelength: $.validator.format("Indtast mindst {0} og højst {1} tegn."),
        email: "Indtast en gyldig email-adresse.",
        url: "Indtast en gyldig URL.",
        date: "Indtast en gyldig dato.",
        number: "Indtast et tal.",
        digits: "Indtast kun cifre.",
        equalTo: "Indtast den samme værdi igen.",
        range: $.validator.format("Angiv en værdi mellem {0} og {1}."),
        max: $.validator.format("Angiv en værdi der højst er {0}."),
        min: $.validator.format("Angiv en værdi der mindst er {0}."),
        creditcard: "Indtast et gyldigt kreditkortnummer.",
      },
      fr: {
        required: "Ce champ est obligatoire.",
        remote: "Veuillez corriger ce champ.",
        email: "Veuillez fournir une adresse électronique valide.",
        url: "Veuillez fournir une adresse URL valide.",
        date: "Veuillez fournir une date valide.",
        dateISO: "Veuillez fournir une date valide (ISO).",
        number: "Veuillez fournir un numéro valide.",
        digits: "Veuillez fournir seulement des chiffres.",
        creditcard: "Veuillez fournir un numéro de carte de crédit valide.",
        equalTo: "Veuillez fournir encore la même valeur.",
        extension: "Veuillez fournir une valeur avec une extension valide.",
        maxlength: $.validator.format("Veuillez fournir au plus {0} caractères."),
        minlength: $.validator.format("Veuillez fournir au moins {0} caractères."),
        rangelength: $.validator.format("Veuillez fournir une valeur qui contient entre {0} et {1} caractères."),
        range: $.validator.format("Veuillez fournir une valeur entre {0} et {1}."),
        max: $.validator.format("Veuillez fournir une valeur inférieure ou égale à {0}."),
        min: $.validator.format("Veuillez fournir une valeur supérieure ou égale à {0}."),
        maxWords: $.validator.format("Veuillez fournir au plus {0} mots."),
        minWords: $.validator.format("Veuillez fournir au moins {0} mots."),
        rangeWords: $.validator.format("Veuillez fournir entre {0} et {1} mots."),
        letterswithbasicpunc: "Veuillez fournir seulement des lettres et des signes de ponctuation.",
        alphanumeric: "Veuillez fournir seulement des lettres, nombres, espaces et soulignages.",
        lettersonly: "Veuillez fournir seulement des lettres.",
        nowhitespace: "Veuillez ne pas inscrire d'espaces blancs.",
      },
    },

    init(lang) {
      const msgObj = this.messages[lang];

      // falls jemals 'require.js' verwendet wird, hier code aus
      // den 'jquery.validate.messages_{lang}.js' zur rate ziehen
      $.extend($.validator.messages, msgObj);
    },
  },

  accountBadge: {
    maxDisplayBadges: 3,
    init() {
      // Daten sammeln
      const c_CustomerIsLoginValidated = window.c_CustomerIsLoginValidated || false;
      const c_CustomerNewsletterFlag = window.c_CustomerNewsletterFlag || false;
      const c_FlashSaleDataPath = window.c_FlashSaleDataPath || "";

      // Prüfen, ob Flash-Sale-Pop-up eingeblendet werden muss. Voraussetzung:
      /* Hide-Flag darf noch nicht gesetzt sein
       * Kunde ist eingeloggt und hat Newsletter-Flag
       * Data-Path darf auf keinen Fall leer sein */
      const flashsaleBadgeCounter =
        c.sessionCookie.get("c_AccountFlashsaleBadgeShown") === false
          ? 0
          : c.sessionCookie.get("c_AccountFlashsaleBadgeShown");
      const hideFlagSet = c.sessionCookie.get("c_hideHeaderFlashsaleBadge") !== false;

      if (
        hideFlagSet ||
        !c_CustomerIsLoginValidated ||
        !c_CustomerNewsletterFlag ||
        c_FlashSaleDataPath === "" ||
        flashsaleBadgeCounter >= 3
      ) {
        return;
      }

      loadFlashsales().then(function (flashsales) {
        // Daten durchgehen und Flashsale suchen, der innerhalb von 24 Stunden endet
        const now = new Date();
        let timeDiff;
        const bestMatch = flashsales[0];

        if (!bestMatch || !bestMatch.endDate) {
          return;
        }

        const end = new Date(bestMatch.endDate);
        const diff = Math.floor((end - now) / (1000 * 60 * 60));
        const isInRange = diff > 0 && diff < 24;

        if (!isInRange) {
          return;
        }

        timeDiff = diff;

        // Counter prüfen, wie oft das Badge schon eingeblendet wurde
        let flashsaleBadgeCounter =
          c.sessionCookie.get("c_AccountFlashsaleBadgeShown") === false
            ? 0
            : c.sessionCookie.get("c_AccountFlashsaleBadgeShown");

        if (flashsaleBadgeCounter >= this.maxDisplayBadges) {
          return;
        }

        // Counter hochzählen
        c.sessionCookie.set("c_AccountFlashsaleBadgeShown", ++flashsaleBadgeCounter);

        // Metadaten des Flashsale aufbereiten und in der sessionStorage zwischenspeichern
        const name = bestMatch.headline;
        const path = bestMatch.path;

        c.sessionCookie.set("c_flashsalePopupName", encodeURIComponent(name));
        c.sessionCookie.set("c_flashsalePopupPath", encodeURIComponent(path));
        c.sessionCookie.set("c_flashsalePopupTime", encodeURIComponent(timeDiff));

        // Badge einblenden und Event binden für Klick und Tracking
        $("#HeaderAccountIconBadge").show();
        $("#HeaderAccountIcon").on("click", function () {
          Tracking.sendEvent("trackFlashsaleBadgeClicked");
          c.sessionCookie.set("c_hideHeaderFlashsaleBadge", "1");
          c.sessionCookie.set("c_showFlashsalePopup", "1");
        });
      });
    },

    showFlashsalePopup(name, remainingTime, path) {
      // Popup-Element selektieren
      const $FlashsalePopup = $("#FlashsalePopup");
      // Textplatzhalter im HTML ersetzen, um die korrekte Bezeichnung usw. anzuzeigen
      let popupHtml = $FlashsalePopup.html();
      popupHtml = popupHtml.replace("[[[SALE_NAME]]]", name);
      popupHtml = popupHtml.replace("[[[SALE_HOURS_REMAINING]]]", remainingTime);
      popupHtml = popupHtml.replace("[[[SALE_PATH]]]", path);
      popupHtml = popupHtml.replace(encodeURI("[[[SALE_PATH]]]"), path);
      $FlashsalePopup.html(popupHtml);
      // Popup einblenden
      $FlashsalePopup.reveal();
    },
  },

  blogNews: {
    init() {
      const $blogNewsDiv = $("#BlogNews");
      if ($blogNewsDiv.length) {
        const blogNewsData = sessionStorage.getItem("c_BlogNewsData");
        if (blogNewsData !== null) {
          c.blogNews.fillSlots($blogNewsDiv, $.parseXML(blogNewsData));

          return;
        }

        const c_BlogNewsDataPath = window.c_BlogNewsDataPath || "";
        if (c_BlogNewsDataPath != "") {
          $.get(
            c_BlogNewsDataPath,
            function (data) {
              sessionStorage.setItem("c_BlogNewsData", data);
              c.blogNews.fillSlots($blogNewsDiv, $.parseXML(data));
            },
            "text",
          );
        } else {
          $blogNewsDiv.closest("section").remove();
        }
      }
    },
    fillSlots($blogNewsDiv, data) {
      const $blogNewsAnchors = $("a.list-products__item", $blogNewsDiv);
      const blogEntries = Array.from(data.getElementsByTagName("BlogEntry"));

      $blogNewsAnchors.each(function (i) {
        $(this).attr({
          "href": $("Path", blogEntries[i]).text(),
          "data-cid": $("CategoryId", blogEntries[i]).text(),
          "data-ctid": $("CategoryTypeId", blogEntries[i]).text(),
        });
        $(this).append($("Name", blogEntries[i]).text());
        $("img", this).attr("src", $("Banner", blogEntries[i]).text());
        $("img", this).attr("alt", $("ImgAltText", blogEntries[i]).text());
      });
      $blogNewsDiv.show();
    },
  },

  mainNavigation: {
    init() {
      // Zuerst Initial-State setzen: Navigation ist nicht geöffnet (nur mobil relevant)
      history.replaceState(Object.assign({}, history.state, {navOpened: 0}), "");

      // lade Dropdowns der Hauptnavigation
      c.mainNavigation.loadNavigation();

      // Hauptnavigation öffnen (nur mobil relevant)
      $("#MobileNavButton").on("click", function () {
        c.mainNavigation.openHeader();
        c.mainNavigation.openMobileNav();
      });
      // Hauptnavigation schließen (nur mobil relevant)
      $("#MobileNavCloseButton").on("click", function () {
        c.mainNavigation.closeMobileNav();
        c.mainNavigation.closeHeader();
      });

      // "Vor"- und "Zurück"-Events abfangen und ggf. Navigation öffnen/schließen
      window.addEventListener("popstate", function (event) {
        // Sicherstellen, dass das Event gemäß Spezifikation befüllt ist, gibt sonst Probleme mit PhantomJS
        if (event.state !== null && event.state.navOpened !== null) {
          if (event.state.navOpened === 1) {
            $("header").addClass("open");
          } else {
            c.mainNavigation.closeMobileNav();
            $("header").removeClass("open");
          }
        }
      });

      // Suche-Dropdown öffnen (Desktop)
      $("#NavSearchButton").on("click", function () {
        c.mainNavigation.closeNav();
      });

      // Suchfeld öffnen (mobil)
      $("#HeaderSearchButton").on("click", function () {
        c.mainNavigation.closeMobileNav();
      });

      // Navigations-Dropdowns öffnen und schließen
      if ($(window).width() >= c.config.breakpointTabletLarge) {
        /* Desktopansicht:
         * HoverIntent sorgt für saubere UX: Menü wird nur geöffnet, wenn der Benutzer wirklich darauf zeigt,
         * nicht wenn er nur schnell mit der Maus darüberfährt */
        $("header .nav-link-dropdown")
          .hoverIntent({
            over() {
              // Bei HoverIntent: Menü öffnen
              c.mainNavigation.openNavDropdown(this);
            },
            out() {
              // Beim Verlassen, Menü schließen, aber erst nach timeout
              $(this).find(".section-nav-dropdown").removeClass("nav-open");
            },
            interval: 50, // internes Prüfinterval für das HoverIntent-Script, 50 ms sorgt für gute "Responsiveness"
            timeout: 400, // wenn die Maus das Menü verlässt, 400 ms warten vorm Schließen
          })
          .on("touchstart", function (e) {
            // Außerdem: Beim antippen des Nav-Elements auf einem Touchscreen mit Tablet-Größe:
            // Nav-Dropdown öffnen, anstatt Link zu folgen (wenn es nicht schon geöffnet ist)
            if ($(this).find(".section-nav-dropdown").hasClass("nav-open")) {
              return;
            }
            e.preventDefault();
            c.mainNavigation.openNavDropdown(this);
          });
      } else {
        /* Mobilansicht:
         * Nav-Dropdowns lassen sich beliebig auf- und zuklappen.
         * Direktes anspringen der Links ist dafür nicht mehr möglich. */
        $("header .nav-link-dropdown .main-navigation-link").on("click", function (e) {
          e.preventDefault();
          const $this = $(this);
          if ($this.closest(".nav-link-dropdown").find(".section-nav-dropdown").hasClass("nav-open")) {
            c.mainNavigation.closeNav();
          } else {
            c.mainNavigation.openNavDropdown($this.closest(".nav-link-dropdown"));
            const $header = $("header");
            const scrollTarget = $this.position().top - 10;
            if ($header.scrollTop() > scrollTarget) {
              $header.scrollTop(scrollTarget);
            }
          }
        });
      }
    },
    // Navigation Dropdowns aus der session, oder asynchron nachladen, wenn Main Navigation existiert
    loadNavigation() {
      const $navLinks = $(".nav-link-dropdown");
      if ($navLinks.length) {
        const navigationData = sessionStorage.getItem("c_NavigationData");
        if (navigationData !== null) {
          c.mainNavigation.embedNavigation($navLinks, navigationData);
        } else {
          const navigationDataPath = $navLinks.parent().data("dropdown-html-path");
          $.get(navigationDataPath, function (navData) {
            sessionStorage.setItem("c_NavigationData", navData);
            c.mainNavigation.embedNavigation($navLinks, navData);
          });
        }
      }
    },
    // Navigation Dropdowns ins aktuelle dom laden
    embedNavigation($navLinks, navData) {
      const htmlData = $.parseHTML(navData);
      $navLinks.each(function (_, navLink) {
        const navLinkSelector = "#" + navLink.dataset.navLinkId + ">section";
        const domNode = $(htmlData).find(navLinkSelector);
        $(navLink).append(domNode);
      });
      const metaLinkDomNode = $(htmlData).find("div.nav-mobile-meta-links__element");
      $(".nav-mobile-meta-links").html(metaLinkDomNode);
    },
    openHeader() {
      $("header").addClass("open");
      // History-State setzen, damit der Zurück-Button des Browsers die Navigation schließen kann
      history.pushState(Object.assign({}, history.state, {navOpened: 1}), "");
    },
    closeHeader() {
      $("header").removeClass("open");
      history.replaceState(Object.assign({}, history.state, {navOpened: 0}), "");
    },
    openMobileNav() {
      $("header").addClass("nav-open");
    },
    closeMobileNav() {
      $("header").removeClass("nav-open");
    },
    openNavDropdown(element) {
      // Evtl. offene Navigation schließen, und neue Aufklappen
      c.mainNavigation.closeNav();
      $(element).find(".section-nav-dropdown").addClass("nav-open");
      // Mobile-Toggle-Button umschalten auf "schließen" (nur relevant für Mobilansicht)
      $(element).find(".main-navigation-link__mobile-toggle").addClass("main-navigation-link__mobile-toggle--close");
      // Tracking-Informationen an GTM senden
      Tracking.setVariable("LastOpenedNavigation", $(element).find("> a").text().trim());
      Tracking.sendEvent("trackNavigationOpened");
      // Lazy-loading für Bilder innerhalb der Navigation starten
      $(element).find("img[data-src]").lazyLoadXT();
    },
    closeNav() {
      // Alle evtl. offenen Menüs schließen, außer das ggf. zuletzt angeklickte
      $(".section-nav-dropdown:not(.nav-last-opened)")
        .removeClass("nav-open")
        .closest(".nav-link-dropdown")
        .find(".main-navigation-link__mobile-toggle")
        .removeClass("main-navigation-link__mobile-toggle--close");
    },
  },

  initProductReview() {
    const $list = $(".product-review-list");
    if (!$list.length) return;
    const $more = $list.find(".product-review-list__more");
    if (!$more.length) return;

    $more.show().on("click", function () {
      $list.addClass("show-all");
      $more.remove();
    });
  },

  /**
   * Geburtstags-Formularfelder initialisieren
   */
  initBirthday() {
    $(".BirthdayDay").on("change", function () {
      $(".BirthdayDay").val($(this).val());
      const newDate =
        $(".BirthdayYear").first().val() +
        "-" +
        $(".BirthdayMonth").first().val() +
        "-" +
        $(".BirthdayDay").first().val();
      if (newDate.length === 10) {
        $("#Birthday").val(newDate);
      } else {
        $("#Birthday").val("");
      }
    });
    $(".BirthdayMonth").on("change", function () {
      $(".BirthdayMonth").val($(this).val());
      const newDate =
        $(".BirthdayYear").first().val() +
        "-" +
        $(".BirthdayMonth").first().val() +
        "-" +
        $(".BirthdayDay").first().val();
      if (newDate.length === 10) {
        $("#Birthday").val(newDate);
      } else {
        $("#Birthday").val("");
      }
    });
    $(".BirthdayYear").on("change", function () {
      $(".BirthdayYear").val($(this).val());
      const newDate =
        $(".BirthdayYear").first().val() +
        "-" +
        $(".BirthdayMonth").first().val() +
        "-" +
        $(".BirthdayDay").first().val();
      if (newDate.length === 10) {
        $("#Birthday").val(newDate);
      } else {
        $("#Birthday").val("");
      }
    });
  },

  specialOffer: {
    init() {
      const $flashsaleOfferInBlog = $(".intext-link-box.sale");
      if ($flashsaleOfferInBlog.length) {
        loadFlashsales().then((flashsales) => {
          c.specialOffer.fillIntextLinkBox($flashsaleOfferInBlog, flashsales);
        });
      }
    },

    fillIntextLinkBox($flashsaleOfferInBlog, flashsales) {
      if (flashsales.length) {
        const nearest = flashsales[0];
        const $BlogCTAImg = nearest.blogCTAImg;
        const $BlogCTAImg2x = nearest.blogCTAImg2x;
        if ($BlogCTAImg.length) {
          const attrObj = {
            src: $BlogCTAImg,
            srcset: $BlogCTAImg + " 1x, " + $BlogCTAImg2x + " 2x",
          };
          $flashsaleOfferInBlog.find("img").attr(attrObj);
        } else {
          $flashsaleOfferInBlog.find("img").attr("src", nearest.banner);
        }
        const $strong = $flashsaleOfferInBlog.find("strong");
        $strong.text("„" + nearest.headline + "” " + $strong.text());
        $flashsaleOfferInBlog.attr("href", nearest.path);
      } else {
        $flashsaleOfferInBlog.remove();
      }
    },
  },

  dropDownText: {
    init() {
      const contents = $(".drop-content").hide();
      const drops = $(".drop-title").on("click", function () {
        const $this = $(this);
        $this.find(".h2").toggleClass("open");
        $this.next(".drop-content").slideToggle();
      });

      contents.find("a").on("click", function (e) {
        const $this = $(this);
        const hash = $this.prop("hash");
        if (hash.length) {
          if ($(hash).length) {
            const $title = $(hash).closest(".drop-title");
            document.location.hash = hash;
            $title.find(".h2").addClass("open");
            $title.next(".drop-content").slideDown();
            $("html, body").animate({scrollTop: $title.offset().top}, "fast");
            e.preventDefault();
          }
        }
      });

      if (document.location.hash) {
        $(document.location.hash)
          .closest(".drop-title")
          .find(".h2")
          .addClass("open")
          .end()
          .next(".drop-content")
          .slideDown();
      }
    },
  },

  accountDeletion($form) {
    const $select = $form.find("select");
    const $text = $form.find("#ReasonText");
    const $otherBlock = $form.find("#Other");
    const $otherInput = $form.find("#OtherText");
    const prefix = $text.data("prefix");

    $select.on("change", function () {
      const $this = $(this);
      switch ($this.val()) {
        case "none":
          $otherBlock.hide();
          $text.val("");
          break;
        case "other":
          $text.val("");
          $otherBlock.show();
          break;
        default:
          $otherBlock.hide();
          $text.val(prefix + " " + $this.val());
      }
    });
    $otherInput.on("keyup", function () {
      $text.val(this.value.length > 3 ? prefix + " " + this.value : "");
    });
  },

  /*
   * Usage:
   * <form data-save="" >...
   *   <div data-save="FIELD_IDENTIFIER" >
   *       <input  />
   *   </div>
   *   <div data-save="FIELD_IDENTIFIER2" >
   *       <input  />
   *   </div>
   * </form>
   *
   * Bei Bedarf erweiterbar für andere Formulare.
   * Derzeit wird nur das aktuelle Formular gespeichert.
   *
   * (bool) useSession SessionStorage, sonst localStorage
   *
   * ck 12-03-2014
   */
  formStorage(useSession) {
    var useSession = typeof useSession !== "undefined" ? useSession : false;
    const storageKey = "FormStorage";

    if (!$("form[data-save]").length) {
      useSession ? sessionStorage.removeItem(storageKey) : localStorage.removeItem(storageKey);

      return;
    }

    const $form = $("form[data-save]");
    const $items = $form.find("[data-save]");
    const fromStorage = c.storage.get(storageKey, true);

    if (fromStorage) {
      $.each($items, function (index, element) {
        const $element = $(element);
        $element.find("input").val(fromStorage.value[$element.data("save")]);
      });
    }

    $form.on("submit", function () {
      const toStorage = {};
      $.each($items, function (index, element) {
        const $element = $(element);
        const $input = $element.find("input");
        toStorage[$element.data("save")] = $input.val();
      });
      c.storage.set(storageKey, toStorage, true);
    });
  },
};

window.c = c;

$(document).ready(function () {
  c.init({lang: $("body").data("lang")});
});
